module.exports = __webpack_public_path__ + "static/img/logo1.4eb6217d.webp";